<template>
    <div class="containerWave">
        <SpeedDial
                v-if="user"
                :model="getSpeedDialItems "
                   tooltipOptions="false"
                   showIcon="pi pi-bars"
                   hideIcon="pi pi-times"
                   type="linear"
                   direction="up"
                   class=" speedial-left"/>

        <transition
                name="custom-classes-transitions"
                enter-active-class="animated fadeIn"
        >
            <router-view/>
        </transition>
<!--        <AddTestDialog-->
<!--                :show="isDialogTestAdd"-->
<!--                v-on:closeDialog="isDialogTestAdd = false"-->
<!--        />-->
        <external-link
                @cancel="isDialogExternalLink = false"
                :show="isDialogExternalLink"
        />
    </div>
</template>

<script>
// import AddTestDialog from "@/dialogs/mainPost/TestMultyDialog"
import ExternalLink from "@/components/externalLink/ExternalLink.vue"
import {mapState} from "vuex";

export default {
    components: {
        // AddTestDialog,
        ExternalLink
    },
    computed: {
        getSpeedDialItems(){
          if (this.user.grade || this.user.role === "ADMIN")  {
              return this.speedDialItems
          } else {
              return this.speedDialItems.filter(item => !item.userGrade)

          }
        },
        ...mapState(["user"])
    },
    data() {
        return {
            isDialogTestAdd: false,
            isDialogExternalLink: false,
            speedDialItems: [
                {
                    label: 'קישורים חיצוניים',
                    icon: 'pi pi-link',
                    command: () => {
                        this.isDialogExternalLink = true
                    },
                    userGrade: false
                },
                {
                    label: 'דיווח מבחנים',
                    icon: 'pi pi-pencil',
                    command: () => {
                        this.$router.push("/test")
                    },
                    userGrade: false
                },
                {
                    label: 'דשבורד תלמיד',
                    icon: 'pi pi-image',
                    command: () => {
                        this.$router.push("/pupil-dashboard")
                    },
                    userGrade: true

                },
            ],
        }
    },
};
</script>

<style scoped>
>>>.speedial-left .p-button:focus {
    -webkit-box-shadow: 0 0 0 0.2rem var(--primary-color-sadow);
    box-shadow: 0 0 0 0.2rem var(--primary-color-sadow);
}
>>>.speedial-left .p-button {
    border: 1px solid  var(--primary-color);
}
>>>.speedial-left .p-speeddial-button.p-button.p-button-icon-only {
    color: unset;

    background-color:   var(--primary-color) !important;

}
.containerWave {
    display: inline-block;
    width: 100%;
    min-height: 80vh;
    vertical-align: middle;
    overflow: hidden;
    position: relative;
    background-position: top;
}

>>> .p-speeddial {
    z-index:10;

    padding: 24px;
    position: fixed;
    bottom: 0;
    left: 0
}
</style>
